import React from 'react';
import ContentLoader from 'react-content-loader';

import { createStyles, ListItem, ListItemText, Theme, withStyles, WithStyles } from '@material-ui/core';

import Avatar from './Avatar';

const styles = ({
  palette: {
    common: { white },
    divider,
  },
}: Theme) =>
  createStyles({
    root: {
      paddingLeft: 42,
      background: white,
      borderTop: `1px solid ${divider}`,
    },
  });

export interface ContentLoaderListItemChatActivityProps extends WithStyles<typeof styles> {}

const ContentLoaderListItemChatActivity: React.FC<ContentLoaderListItemChatActivityProps> = ({ classes, ...rest }) => (
  <ListItem className={classes.root}>
    <Avatar color="#ecebeb">&nbsp;</Avatar>
    <ListItemText
      primary={
        <ContentLoader width={200} height={15}>
          <rect x="0" y="7" rx="0" ry="0" width="120" height="10" />
        </ContentLoader>
      }
      secondary={
        <ContentLoader width={200} height={15}>
          <rect x="0" y="5" rx="0" ry="0" width="150" height="7" />
        </ContentLoader>
      }
    />
  </ListItem>
);

export default withStyles(styles)(ContentLoaderListItemChatActivity);
